import { createWeb3Modal, defaultConfig } from '@web3modal/ethers5'
import { ConnectionStatus } from './Globals.js'
import { LitElement } from 'lit'

class WalletConnect extends LitElement {
  constructor() {
    super()
  }
}

// WALLET CONNECT SETUP
const projectId = '62440019cf8e8c1540e88c13266171a1'
// Chain setup to be used in WalletConnect Modal

const networkList = [
  {
    key: 'testnet',
    chainId: 43113,
    name: 'Fuji',
    currency: 'AVAX',
    explorerUrl: 'https://testnet.snowtrace.io/',
    rpcUrl: 'https://api.avax-test.network/ext/bc/C/rpc',
  },
  {
    key: 'avalanche',
    chainId: 43114,
    name: 'Avalanche',
    currency: 'AVAX',
    explorerUrl: 'https://snowtrace.io/',
    rpcUrl: 'https://api.avax.network/ext/bc/C/rpc',
  },
  {
    key: 'sepolia',
    chainId: 11155111,
    name: 'Sepolia',
    currency: 'SepoliaETH',
    explorerUrl: 'https://sepolia.etherscan.io',
    rpcUrl: 'https://ethereum-sepolia-rpc.publicnode.com',
  },
  {
    key: 'anvil',
    chainId: 31337,
    name: 'Anvil',
    currency: 'GO',
    explorerUrl: 'http://localhost:8545',
    rpcUrl: 'http://localhost:8545',
  },
]

export const networks = Object.fromEntries(
  networkList.map(({ key, ...rest }) => [key, rest])
)

const metadata = {
  name: 'Kula Client',
  description: '',
  url: 'https://kula-dao-client-pr-125.onrender.com/login',
  icons: [''],
}

const ethersConfig = defaultConfig({
  metadata,
  enableEIP6963: true,
  enableInjected: true,
  enableCoinbase: true,
  rpcUrl: '...',
  defaultChainId: 1,
})
const modal = createWeb3Modal({
  ethersConfig,
  chains: [
    networks.testnet,
    networks.avalanche,
    networks.sepolia,
    networks.anvil,
  ],
  projectId,
  enableAnalytics: true,
  enableOnramp: true,
  themeVariables: {
    '--w3m-z-index': 9999,
  },
})

// Used to open the WalletConnect Modal from any view by dipatching an event
window.addEventListener('modal-connect', async () => {
  modal.open()
})
window.addEventListener('modal-network', async () => {
  modal.open({ view: 'Networks' })
})

/**
 * @returns {boolean}
 */
export function checkModalConnection() {
  return !!modal.getIsConnected()
}

// Dipatches an event when the connection status of the WalletConnect Modal changes
function handleConnect({ isConnected }) {
  window.dispatchEvent(
    new CustomEvent('wallet-connect', {
      detail: { isConnected },
    })
  )

  // Update globals when disconnected
  if (!isConnected) {
    window.Globals.update({
      status: ConnectionStatus.DISCONNECTED,
      selectedAccount: null,
      accounts: [],
      wallets: [],
    })
  }

  return isConnected
}
modal.subscribeProvider(handleConnect)

export async function getAddressFromModal() {
  const address = modal.getAddress()
  return address
}

export default WalletConnect
